import { Parent } from '../types';

export const mockParents: Parent[] = [
  {
    id: '650e8400-e29b-41d4-a716-446655440001',
    firstName: 'Michael',
    lastName: 'Johnson',
    email: 'michael.johnson@email.com',
    phone: '555-0101',
    studentIds: ['550e8400-e29b-41d4-a716-446655440001'],
    address: '123 Oak Street',
    city: 'Springfield',
    state: 'IL',
    zipCode: '62701',
  },
  {
    id: '650e8400-e29b-41d4-a716-446655440002',
    firstName: 'Sarah',
    lastName: 'Smith',
    email: 'sarah.smith@email.com',
    phone: '555-0102',
    studentIds: ['550e8400-e29b-41d4-a716-446655440002'],
    address: '456 Maple Avenue',
    city: 'Springfield',
    state: 'IL',
    zipCode: '62702',
  },
  {
    id: '650e8400-e29b-41d4-a716-446655440003',
    firstName: 'David',
    lastName: 'Williams',
    email: 'david.williams@email.com',
    phone: '555-0103',
    studentIds: ['550e8400-e29b-41d4-a716-446655440003'],
    address: '789 Pine Road',
    city: 'Springfield',
    state: 'IL',
    zipCode: '62703',
  },
  {
    id: '650e8400-e29b-41d4-a716-446655440004',
    firstName: 'Jennifer',
    lastName: 'Brown',
    email: 'jennifer.brown@email.com',
    phone: '555-0104',
    studentIds: ['550e8400-e29b-41d4-a716-446655440004'],
    address: '321 Elm Drive',
    city: 'Springfield',
    state: 'IL',
    zipCode: '62704',
  },
  {
    id: '650e8400-e29b-41d4-a716-446655440005',
    firstName: 'Robert',
    lastName: 'Davis',
    email: 'robert.davis@email.com',
    phone: '555-0105',
    studentIds: ['550e8400-e29b-41d4-a716-446655440005'],
    address: '654 Cedar Lane',
    city: 'Springfield',
    state: 'IL',
    zipCode: '62705',
  },
  {
    id: '650e8400-e29b-41d4-a716-446655440006',
    firstName: 'Lisa',
    lastName: 'Johnson',
    email: 'lisa.johnson@email.com',
    phone: '555-0106',
    studentIds: ['550e8400-e29b-41d4-a716-446655440001', '550e8400-e29b-41d4-a716-446655440002'],
    address: '987 Birch Court',
    city: 'Springfield',
    state: 'IL',
    zipCode: '62706',
  },
];
